@if (autoRepeatEnabled()) {
  <button
    class="action-button action-button--secondary-action"
    mat-flat-button
    [disabled]="actionsDisabled()"
    (click)="saveAndContinue.emit()"
  >
    <div class="action-button__content">
      <mat-icon class="action-button__icon">add_task</mat-icon>
      <span class="truncate" title="Speichern und erneut hinzufügen">Speichern und erneut hinzufügen</span>
    </div>
  </button>
} @else {
  <button class="action-button" mat-button (click)="cancelEdit.emit()">
    <div class="action-button__content">
      <span class="truncate" title="Abbrechen">Abbrechen</span>
    </div>
  </button>
}

<button class="action-button" mat-flat-button color="accent" [disabled]="actionsDisabled()" (click)="save.emit()">
  <div class="action-button__content">
    <mat-icon class="action-button__icon">task_alt</mat-icon>
    <span class="truncate" title="Speichern">Speichern</span>
  </div>
</button>
